export default __webpack_public_path__ + "static/media/logoLingo.4b1e65fa.png";